import { TW_AppBlogArticle, TW_AppBlogArticleImage, TW_AppBlogParagraphMargin } from '@utils/twClasses';
import kpi1 from '@img/KPI_1.png';
import kpi2 from '@img/KPI_2.png';
import camembert1 from '@img/Camembert_1.png';
import camembert2 from '@img/Camembert_2.png';
import dashboard1 from '@img/Dashboard_1.png';
import barres1 from '@img/Barres_1.png';
import barres2 from '@img/Barres_2.png';
import lignes1 from '@img/Lignes_1.png';
import lignes2 from '@img/Lignes_2.png';
import radar1 from '@img/Radar_1.png';
import dashboard from '@img/Dashboard.gif';

export default function Page() {

    return (
        <div className={TW_AppBlogArticle}>
            <h1 className="mb-6 text-3xl font-semibold text-black">
                Dashboards
            </h1>
            <p className={TW_AppBlogParagraphMargin}>This is probably the most interesting tool for a company in terms of data management: a dashboard that allows you to see at a glance the key data for your business, to help you make the best decisions.</p>
            <p className={TW_AppBlogParagraphMargin}>It was obviously a feature that Compozz couldn't do without. And although we thought dashboards would be easy to configure, we know that the configuration of your first dashboard may seem difficult to you. That's why we'll see together the different options that are available to you.</p>
            <p className={TW_AppBlogParagraphMargin}>If you haven't already created a dashboard, go ahead. You should see a blank page with the following message: "No components defined. Pass to edit mode to add components.”. Click on the “Edit mode” button on the top right and then on “Add a component”.</p>
            <p className={TW_AppBlogParagraphMargin}>In the pop-up that appears, choose a name for the component you are creating. You must then choose the type of your component from 5 possibilities. </p>
            <p className={TW_AppBlogParagraphMargin}>Let's start with the <span className='font-semibold'>key indicator (KPI) </span>. This component allows you to display a unique value. In our case, we choose to display the total amount of invoices that we have entered in our data model. </p>
            <p>For this, it is enough to select the “Amount” field of the “Invoice” object and to sum the amounts by selecting the aggregation mode “Sum”. </p>
            <img 
                src={kpi1}
                alt="Creation of a key indicator" 
                width={1275}
                height={525}
                className={TW_AppBlogArticleImage}
            />
            <p>But we want to go a little further and see only the total amount of invoices paid in 2025. We therefore apply the following filters:</p>
            <img 
                src={kpi2}
                alt="Application of a filter on the key indicator" 
                width={1275}
                height={525}
                className={TW_AppBlogArticleImage}
            />
            <p className={TW_AppBlogParagraphMargin}>Click on “Add”, your first component then appears on your dashboard. To create a new one, hover over the component just added, + signs appear on each side of the component, they allow you to add components above, to the right, below or to the left of it.</p>
            <p>Let's now pass to the <span className='font-semibold'>pie chart</span>. With our data model, we would like to see the distribution of projects according to the sectors of activity. We therefore select the “Name” field of our “Project” object and we count the number of projects by selecting the aggregation mode “Count”. </p>
            <img 
                src={camembert1}
                alt="Creation of a pie chart" 
                width={1278}
                height={528}
                className={TW_AppBlogArticleImage}
            />
            <p>A new configuration field has appeared, it is this one that will allow us to define how we will distribute our projects. We therefore choose the activity sector of the companies related to these projects.</p>
           <img 
                src={camembert2}
                alt="Configuration of a pie chart" 
                width={1278}
                height={528}
                className={TW_AppBlogArticleImage}
            />
            <p>You can add filters, adjust the dimensions or choose to display or not the legend. Click on Add.</p>
            <img 
                src={dashboard1}
                alt="View of a dashboard" 
                width={1274}
                height={588}
            />
            <p className={TW_AppBlogParagraphMargin}>We could also represent this data in the form of <span className='font-semibold'>bars</span>. Add a component to the right of the pie chart.</p>
            <p className={TW_AppBlogParagraphMargin}>As for the pie chart, we choose the name of the projects to display.</p>
            <p>A “Separate by” field has appeared. As its name suggests, this field allows us to choose how the bars will be separated. For us, it will be by the activity sector.</p>
            <img 
                src={barres1}
                alt="Creation of a bar graph" 
                width={1272}
                height={766}
                className={TW_AppBlogArticleImage}
            />
            <p className={TW_AppBlogParagraphMargin}>The “categories” field appears. It allows you to choose a value to “split” each bar according to this value. We want to see the status of projects by activity sector. Thus each activity sector is now divided into 4 bars that correspond to our statuses (Coming soon, Abandoned, In progress and Completed). </p>
            <img 
                src={barres2}
                alt="Configuration of a bar graph" 
                width={1272}
                height={766}
                className={TW_AppBlogArticleImage}
            />
            <p className={TW_AppBlogParagraphMargin}>Let's now pass to the <span className='font-semibold'>linear graph</span>. We have created an “Skills” object in our data model. We have defined skills, assigned them to collaborators that we have rated from 0 to 10. </p>
            <p className={TW_AppBlogParagraphMargin}>We want to use this graph to see how skills are distributed among collaborators. The value we want to display is therefore the note from 0 to 10. </p>
            <p>The notes are separated according to the skill, which in our model corresponds to the “Type” field. For now, here is what we see:</p>
            <img 
                src={lignes1}
                alt="Creation of a linear graph" 
                width={1272}
                height={766}
                className={TW_AppBlogArticleImage}
            />
            <p>Not really conclusive. We are missing a dimension: the category. By choosing here the “Name” or “First name” field of the “Collaborator” object, we will obtain the desired result, namely a line per collaborator.</p>
            <img 
                src={lignes2}
                alt="Configuration of a linear graph" 
                width={1272}
                height={766}
                className={TW_AppBlogArticleImage}
            />
            <p className={TW_AppBlogParagraphMargin}>We like the representation of skills in the form of a metro map, but we also have a last type of graph that could be more adapted in this case: <span className='font-semibold'>the radar</span>.</p>
            <p>We will configure it in the same way as the linear graph:</p>
                <ul className='list-disc list-inside ml-4 mb-5'>
                    <li>The value to display is the skill note</li>
                    <li>The separation of values is done according to the skills</li>
                    <li>And we want to have a layer per collaborator on our graph, so we choose the “Name” or “First name” field of the collaborator rated.</li>
                </ul>
            <p>We then obtain the following result:</p>
            <img 
                src={radar1}
                alt="Creation of a radar graph" 
                width={1264}
                height={528}
                className={TW_AppBlogArticleImage}
            />
            <p>We have just created our first dashboard. It's your turn now to create relevant dashboards for your business! </p>
            <img 
                src={dashboard}
                alt="View of a completed dashboard" 
                width={1600}
                height={646}
                className={TW_AppBlogArticleImage}
            />
            <p className={TW_AppBlogParagraphMargin}></p>

        </div>
    )
}